import React, { useEffect, useState } from "react";
import "../assets/Loan/LoanReport.css";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAllLoans,
  deleteLoan,
} from "../redux/slices/loan/loanReportSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileCsv,
  faFileExcel,
  faPrint,
  faSortUp,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx-js-style";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";

const LoanStatement = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loans, loading, error } = useSelector((state) => state.loanReport);
      const { profile } = useSelector((state) => state.userProfile);

  const [filters, setFilters] = useState({
    loanAccountNumber: "",
    customerName: "",
    customerId:""
  });
  const [currentPage, setCurrentPage] = useState(1);
      const [company, setCompany] = useState(null);
  const [itemsPerPage, setItemsPerPage] = useState(10);


      const formatDateDDMMYY = (dateStr) => {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yy = String(d.getFullYear());
  return `${dd}-${mm}-${yy}`;
};

        useEffect(() => {
        dispatch(fetchUserProfile());
      }, [dispatch]);

  useEffect(() => {
    dispatch(fetchAllLoans());
  }, [dispatch]);

  // 🔹 Input filter handler
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };
  const handleChange = (e) => {
    const value = Number(e.target.value);
    setItemsPerPage(value);
    console.log("Items per page:", value); // optional: send to parent or API
  };


    useEffect(()=>{
        const fetchCompany = async () => {
        try {
          const res = await fetch(
            `https://payyug.in/api/get-company?superAdminId=${profile?.superAdminId}`
          );
          const data = await res.json();
          if (res.ok && data) {
            if (data.logo)
              data.logoUrl = `https://payyug.in/${data.logo.replace(/^images\//, "")}`;
            setCompany(data);
          }
        } catch (err) {
          console.error("Failed to fetch company details", err);
        }
      };
      fetchCompany();
    },[profile?.superAdminId])

  // 🔹 Apply search filters
  const applyFilters = (loan) => {
    const { loanAccountNumber, customerName,customerId } = filters;
    const isLoanAccountMatch =
      !loanAccountNumber ||
      loan.loanAccountNumber
        ?.toLowerCase()
        .includes(loanAccountNumber.toLowerCase());
    const isCustomerNameMatch =
      !customerName ||
      loan.userName?.toLowerCase().includes(customerName.toLowerCase());
    const isCustomerIdMatch =
      !customerId ||
      loan.customerId?.toLowerCase().includes(customerId.toLowerCase());
    return isLoanAccountMatch && isCustomerNameMatch && isCustomerIdMatch;
  };

  const filteredLoans = Array.isArray(loans) ? loans.filter(applyFilters) : [];

  // 🔹 Pagination Logic
  const totalItems = filteredLoans.length;
  const totalPages =
    itemsPerPage === "all" ? 1 : Math.ceil(totalItems / itemsPerPage);
  const startIndex =
    itemsPerPage === "all" ? 0 : (currentPage - 1) * itemsPerPage;
  const endIndex =
    itemsPerPage === "all" ? totalItems : startIndex + itemsPerPage;
  const paginatedLoans = filteredLoans.slice(startIndex, endIndex);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(
      e.target.value === "all" ? "all" : parseInt(e.target.value, 10)
    );
    setCurrentPage(1);
  };

const handlePrintLoanStatement = (loan) => {
  navigate(`/Print/LoanStatement/${loan.id}`, {
    state: { loan },
  });
};



  // 🔹 Export to Excel
  const exportExcel = () => {
    const data = paginatedLoans.map((loan) => ({
      "Loan Account": loan.loanAccountNumber,
      "Customer Name": loan.userName,
      "Loan Amount": loan.loanAmount,
      "Loan Scheme": loan.loanService,
      "ROI (%)": loan.loanRoi,
      "Applied Date": `${formatDateDDMMYY(loan.loanAppliedDate)}`,
      "Disbursal Date": `${formatDateDDMMYY(loan.disbursalDate)}`,
      "Loan Type": loan.loanType,
    }));
    const worksheet = XLSX.utils.json_to_sheet(data);
    // 🔹 Header styling
      const headerCells = Object.keys(data[0]);
      headerCells.forEach((_, index) => {
        const cellRef = XLSX.utils.encode_cell({ r: 0, c: index });
        worksheet[cellRef].s = {
          font: {
            bold: true,
            color: { rgb: "FFFFFF" },
          },
          fill: {
            fgColor: { rgb: "1F4E78" }, // dark blue
          },
          alignment: {
            horizontal: "center",
            vertical: "center",
          },
        };
      });
       // 🔹 Auto column width
  worksheet["!cols"] = headerCells.map((key) => ({
    wch: Math.max(key.length + 5, 18),
  }));
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Loans");
    XLSX.writeFile(workbook, "LoanStatementReport.xlsx");
  };

  // 🔹 Export to CSV
  const exportCSV = () => {
    const data = paginatedLoans.map((loan) => ({
      "Loan Account": loan.loanAccountNumber,
      "Customer Name": loan.userName,
      "Loan Amount": loan.loanAmount,
      "Loan Scheme": loan.loanService,
      "ROI (%)": loan.loanRoi,
      "Applied Date":`'${formatDateDDMMYY(loan.loanAppliedDate)}`,
    "Disbursal Date":`'${formatDateDDMMYY(loan.disbursalDate)}`,
      "Loan Type": loan.loanType,
    }));
    const worksheet = XLSX.utils.json_to_sheet(data);
    const csvOutput = XLSX.utils.sheet_to_csv(worksheet);
    const blob = new Blob([csvOutput], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, "LoanStatementReport.csv");
  };

  // 🔹 Export to PDF
  const exportPDF =async () => {
     const doc = new jsPDF("p", "mm", "a4");
          const pageWidth = doc.internal.pageSize.width;
          const pageHeight = doc.internal.pageSize.height;

                  // ================= LOGO =================
const logoX = 15;
const logoY = 12;
const logoSize = 25;
const logoPadding = 2;

// Border color & thickness
doc.setDrawColor(0);
doc.setLineWidth(0.2);

// Calculate center of logo
const centerX = logoX + logoSize / 2;
const centerY = logoY + logoSize / 2;

// Radius = half of logo + padding
const radius = logoSize / 2 + logoPadding;

// Draw circle
doc.circle(centerX, centerY, radius);


// Logo image
if (company?.logoUrl) {
  try {
    const logoResp = await fetch(company.logoUrl);
    const logoBlob = await logoResp.blob();
    const reader = new FileReader();
    await new Promise((resolve) => {
      reader.onload = () => {
        doc.addImage(reader.result, "PNG", logoX, logoY, logoSize, logoSize);
        resolve();
      };
      reader.readAsDataURL(logoBlob);
    });
  } catch {
    // silent fail
  }
}

  // ================= COMPANY NAME (AUTO WRAP) =================
  doc.setFont("helvetica", "bold");
  doc.setFontSize(14);

  const nameX = logoX + logoSize + 5;
  const nameY = 18;
  const nameMaxWidth = pageWidth - nameX - 15;

  const companyNameText = doc.splitTextToSize(
    (company?.name || "COMPANY NAME").toUpperCase(),
    nameMaxWidth
  );

  doc.text(companyNameText, nameX, nameY);

  // Calculate Y after company name
  let currentY = nameY + companyNameText.length * 6;

  // ================= COMPANY DETAILS =================
  doc.setFont("helvetica", "normal");
  doc.setFontSize(11);

  const detailX = nameX;
  const detailMaxWidth = nameMaxWidth;

  // Address
  const addressText = doc.splitTextToSize(
    company?.address || "Company Address",
    detailMaxWidth
  );
  doc.text(addressText, detailX, currentY);
  currentY += addressText.length * 5;

  // Email
  const emailText = doc.splitTextToSize(
    `Email: ${company?.email || "-"}`,
    detailMaxWidth
  );
  doc.text(emailText, detailX, currentY);
  currentY += emailText.length * 5;

  // Phone
  const phoneText = doc.splitTextToSize(
    `Phone: ${company?.contact || "-"}`,
    detailMaxWidth
  );
  doc.text(phoneText, detailX, currentY);
  currentY += phoneText.length * 5;

  // Divider
  doc.line(10, currentY + 4, pageWidth - 10, currentY + 4);

  // ================= REPORT TITLE =================
  doc.setFont("helvetica", "bold");
  doc.setFontSize(13);
  doc.text(
    "Loan Statemtent Report",
    pageWidth / 2,
    currentY + 14,
    { align: "center" }
  );

    const tableColumn = [
      "SN",
      "Loan Account",
      "Customer Name",
      "Loan Amount",
      "Loan Scheme",
      "ROI (%)",
      "Applied Date",
      "Disbursal Date",
      "Loan Type",
    ];
    const tableRows = [];

    paginatedLoans.forEach((loan, index) => {
      const loanData = [
        index + 1,
        loan.loanAccountNumber,
        loan.userName,
        loan.loanAmount,
        loan.loanService,
        loan.loanRoi,
        loan.loanAppliedDate?.slice(0, 10),
        loan.disbursalDate?.slice(0, 10),
        loan.loanType,
      ];
      tableRows.push(loanData);
    });

       autoTable(doc, {
            head: [tableColumn],
            body: tableRows,
            startY:currentY+ 20,
             theme: "grid",
        styles: {
          fontSize: 7,
          cellPadding: 3,
          halign: "center",
        },
        headStyles: {
          fontStyle: "bold",
          fontSize: 7,
        },
        footStyles: {
          fillColor: [220, 220, 220],
          textColor: 20,
          fontStyle: "bold",
          fontSize: 8,
        },
        alternateRowStyles: {
          fillColor: [245, 245, 245],
        },
    });
    doc.save("LoanStatementReport.pdf");
  };

  return (
    <div className="BranchLoanReport-container">
      <h2 style={{textAlign:"center"}}>Loan Statement</h2>
      {/* 🔹 Filter Section */}
      <section className="BranchLoanReport-filter">
        {/* <h2 className="BranchLoanReport-filter-title">Loan Statement Filter</h2>
        <p className="BranchLoanReport-filter-subtitle">
          Use filters to view specific loan statements
        </p> */}

        <form
          className="BranchLoanReport-form"
          onSubmit={(e) => e.preventDefault()}
        >
          <div className="BranchLoanReport-form-group">
            <label>Loan Account Number</label>
            <input
              type="text"
              name="loanAccountNumber"
              placeholder="Enter loan account number"
              value={filters.loanAccountNumber}
              onChange={handleInputChange}
            />
          </div>

          <div className="BranchLoanReport-form-group">
            <label>Customer Name</label>
            <input
              type="text"
              name="customerName"
              placeholder="Enter customer name"
              value={filters.customerName}
              onChange={handleInputChange}
            />
          </div>
          <div className="BranchLoanReport-form-group">
            <label>Customer Id</label>
            <input
              type="text"
              name="customerId"
              placeholder="Enter Customer Id"
              value={filters.customerId}
              onChange={handleInputChange}
            />
          </div>

          <div className="BranchLoanReport-actions">
            <button type="submit" className="BranchLoanReport-btn-submit">
              Submit
            </button>
          </div>
        </form>
      </section>

      {/* 🔹 Loan Details */}
      <section className="BranchLoanReport-details">
        {/* Export Buttons */}
        <div className="BranchLoanReport-header">
          <div className="BranchLoanReport-header-left">
            <h2 className="BranchLoanReport-details-title">Loan Details</h2>

            <div className="BranchLoanReport-items-per-page">
              <label htmlFor="itemsPerPage">Items per page:</label>
              <select
                id="itemsPerPage"
                value={itemsPerPage}
                onChange={handleChange}
              >
                <option value={10}>10</option>
                <option value={25}>25</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
                <option value={50000}>All</option>
              </select>
            </div>
          </div>

          <div className="BranchLoanReport-header-actions">
            <button className="BranchLoanReport-btn-csv" onClick={exportCSV}>
              <FontAwesomeIcon icon={faFileCsv} /> CSV
            </button>
            <button
              className="BranchLoanReport-btn-excel"
              onClick={exportExcel}
            >
              <FontAwesomeIcon icon={faFileExcel} /> Excel
            </button>
            <button className="BranchLoanReport-btn-print" onClick={exportPDF}>
              <FontAwesomeIcon icon={faPrint} /> PDF
            </button>
          </div>
        </div>

        {/* Items per page selector */}

        {/* Loan Table */}
        <div className="BranchLoanReport-table-wrapper">
          <table className="BranchLoanReport-table">
            <thead>
              <tr>
                <th>
                  SN. <FontAwesomeIcon icon={faSortUp} />
                </th>
                <th>Account Number</th>
                <th>Customer Id</th>
                <th>Customer Name</th>
                <th>Loan Amount</th>
                <th>Loan Scheme</th>
                <th>ROI (%)</th>
                <th>Disbursal Date</th>
                <th>Loan Type</th>
                <th>Loan Status</th>
                <th>Loan Statement</th>
              </tr>
            </thead>

            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="15">Loading...</td>
                </tr>
              ) : error ? (
                <tr>
                  <td colSpan="15" style={{ color: "red" }}>
                    {error}
                  </td>
                </tr>
              ) : paginatedLoans.length > 0 ? (
                paginatedLoans.map((loan, index) => {
                  const loanStatus = loan.status?.toLowerCase();
                  return (
                    <tr className={
                        loanStatus.toLowerCase() === "closed"
                          ? "closed-row"
                          : loanStatus.toLowerCase() === "requested"
                            ? "requested-row"
                            : ""
                      } key={loan.id || index}>
                      <td>{startIndex + index + 1}</td>
                      <td>{loan.loanAccountNumber || "N/A"}</td>
                      <td>{loan.customerId || "N/A"}</td>
                      <td>{loan.userName || "N/A"}</td>
                      <td>
                        ₹{Number(loan.loanAmount || 0).toLocaleString("en-IN")}
                      </td>
                      <td>{loan.loanService ?? "N/A"}</td>
                      <td>{loan.loanRoi ?? "N/A"}</td>
                      <td>{formatDateDDMMYY(loan.disbursalDate) || "N/A"}</td>
                      <td>{loan.loanType || "N/A"}</td>
                      <td className={`Status-${loanStatus.toLowerCase()}`}>
                        {loan.status || "N/A"}
                      </td>
                      <td>
                        {loanStatus === 'disbursed' ? (
                          <button className="BranchLoanReport-btn-loan-card" onClick={() => handlePrintLoanStatement(loan)}>Loan Statement</button>
                         ) : <span className="BranchLoanReport-na">N/A</span>}
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="15">No loan records found.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination Controls */}
        {itemsPerPage !== "all" && (
          <div className="BranchLoanReport-pagination">
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className="prevbtn"
            >
              Prev
            </button>
            <span>
              {" "}
              Page {currentPage} of {totalPages}{" "}
            </span>
            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        )}
      </section>

    </div>
  );
};

export default LoanStatement;
